"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateMarketingFreeSettings = exports.loadMarketingFreeSettings = void 0;

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var loadMarketingFreeSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.get,
  initiatingActionType: _actions.MarketingFreeSettingsActionType.LOAD_MARKETING_FREE_SETTINGS,
  requestStatusSelector: _selectors.getFetchMarketingFreeSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_ONCE,
  requestActions: _actions.FetchMarketingFreeSettings
}));
exports.loadMarketingFreeSettings = loadMarketingFreeSettings;
var updateMarketingFreeSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.update,
  initiatingActionType: _actions.MarketingFreeSettingsActionType.UPDATE_MARKETING_FREE_SETTINGS,
  requestStatusSelector: _selectors.getUpdateMarketingFreeSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.UpdateMarketingFreeSettings
}));
exports.updateMarketingFreeSettings = updateMarketingFreeSettings;

var _default = (0, _reduxObservable.combineEpics)(loadMarketingFreeSettings, updateMarketingFreeSettings);

exports.default = _default;